import style from './CenterHomeFilters.module.css';

function ButtonsSelect(props) {
  const { options, value, onChange, field } = props;
  return (
    <div className={style.buttons_select}>
      {options.map((item, index) => {
        return (
          <div
            onClick={() => onChange({ field, value: item.value })}
            className={[
              style.buttons_select_option,
              value.includes(item.value) ? style.buttons_select_active : '',
            ].join(' ')}
            key={`${item.label}-${index}`}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
}

export default ButtonsSelect;
